function Testimonial() {
  return <div className="testimonial_area">kjdkhga</div>;
}

export default Testimonial;
